import {Component} from "@angular/core";
import {CartService} from "../../service/cart";
import {ActivatedRoute} from "@angular/router";
import {ApiService} from "../../service/api";

@Component({
    selector: 'app-shipmentinfo',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.scss']
})
export class ShipmentInfoComponent {
    public selected: string;
    public objectKeys = Object.keys;
    public categories: any[] = [];

    constructor(public api: ApiService, public cart: CartService, public route: ActivatedRoute) {
        this.api.call('/article/index/shipmentCategories', {}, "", false, false, true).then((result) => {
            this.categories = result;
        })
    }

    category(id) {
        var result = null;
        this.categories.forEach((item) => {
            if (item.id == id) result = item;
        })

        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/shipment/info.component.ts